import { getProgramWorkspaceDirtyCount } from './programEditWorkspace';
import { hasAnyPendingLearningWorksheetDrafts } from './learningContentWorksheetPendingStorage';
import { hasAnyPendingProgramContentSlideDrafts } from '../services/programContentSlideService';

/** 고정/프로젝트/편제 프로그램 진도 편집 라우트 */
export function isProgramProgressRoute(pathname: string): boolean {
  return pathname.startsWith('/program/');
}

export function isAnnualProgressRoute(pathname: string): boolean {
  return pathname === '/annual-progress-term1' || pathname === '/annual-progress-term2';
}

/** 프로그램 진도표(고정/프로젝트/편제) — 동일 패밀리 내 이동 시 이탈 확인 없음. 연간진도표는 별도 라우트 */
export function isProgramProgressFamilyRoute(pathname: string): boolean {
  return isProgramProgressRoute(pathname);
}

/** 패밀리 밖으로 나갈 때 이탈 확인이 필요한지(활성 페이지 플래그 + LS 워크스페이스·슬라이드·활동지 초안) */
export function isProgramProgressFamilyLeaveDirty(programProgressDirtyFlag: boolean): boolean {
  if (programProgressDirtyFlag) return true;
  if (getProgramWorkspaceDirtyCount() > 0) return true;
  if (hasAnyPendingProgramContentSlideDrafts()) return true;
  if (hasAnyPendingLearningWorksheetDrafts()) return true;
  return false;
}
